import { isMobileViewport, slideUp, slideDown } from '@globals/utils/functions';

class MainFooter {
	footer: HTMLElement | null;
	footerNavItems: NodeListOf<Element> | null;
	breakpoints: IBreakpoints | undefined;
	isMobile: boolean;

	constructor() {
		this.footer = document.querySelector<HTMLElement>('.main-footer');
		this.footerNavItems =
			this.footer?.querySelectorAll('.footer-nav__nav-item--has-dropdown') || null;
		this.breakpoints = window.impBreakpoints;
		this.isMobile = false;
	}

	init() {
		if (this.breakpoints) {
			this.isMobile = isMobileViewport(this.breakpoints);
		}

		if (this.footerNavItems) {
			this.footerNavItems.forEach((item) => {
				const link = item.querySelector<HTMLAnchorElement>('.footer-nav__nav-link');
				if (link) {
					link.addEventListener('click', this.handleFooterDropdownClick.bind(this));
				}
			});
		}
	}

	resized() {
		const wasMobile = this.isMobile;
		if (this.breakpoints) {
			this.isMobile = isMobileViewport(this.breakpoints);
		}

		// Reset all dropdowns when transitioning from mobile to desktop
		if (!this.isMobile && wasMobile) {
			this.resetFooterDropdowns();
		}
	}

	handleFooterDropdownClick(event: MouseEvent) {
		// Only handle clicks on mobile
		if (!this.isMobile) {
			return;
		}

		event.preventDefault();

		const link = event.currentTarget as HTMLAnchorElement;
		const parent = link.parentElement as HTMLElement;
		const submenu = parent?.querySelector<HTMLElement>('ul');

		if (!parent || !submenu) {
			return;
		}

		const isActive = parent.classList.contains('active');

		if (isActive) {
			parent.classList.remove('active');
			slideUp(submenu, { duration: 500, transition: 'cubic-bezier(0, 0, 0.13, 1.39)' });
		} else {
			parent.classList.add('active');
			slideDown(submenu, { duration: 500, transition: 'cubic-bezier(0, 0, 0.13, 1.39)' });
		}
	}

	resetFooterDropdowns() {
		if (!this.footerNavItems) {
			return;
		}

		this.footerNavItems.forEach((item) => {
			const submenu = item.querySelector<HTMLElement>('ul');
			if (submenu) {
				item.classList.remove('active');
				submenu.style.display = '';
				submenu.style.height = '';
				submenu.style.overflow = '';
			}
		});
	}
}

export default new MainFooter();
